import { RootState } from '../@types/RootState';

export const selectorUser = (state: RootState) => {
  return state.clienteDataReducer?.clienteData;
};
